import React from 'react';

import {
  Table,
  TagChip,
} from 'vindi-ds-components';

import toBrl from '@utils/format_currency';
import getPropsTagChipStatus from '../utils/get_props_tag_chip_status';

const columns = [
  {
    label: 'ID',
    align: 'left',
  },
  {
    label: 'ID Cliente',
    align: 'right',
  },
  {
    label: 'Emissão',
    align: 'left',
  },
  {
    label: 'Vencimento',
    align: 'left',
  },
  {
    label: 'Código cliente',
    align: 'left',
  },
  {
    label: 'Nome',
    align: 'left',
  },
  {
    label: 'Método de pagamento',
    align: 'left',
  },
  {
    label: 'Valor',
    align: 'right',
  },
  {
    label: 'Status',
    align: 'left',
  },
];

const TableBills = ({ bills }) => (
  <Table.Container>
    <Table.Head columns={columns} />
    <Table.Body>
      {
        bills?.map((bill) => (
          <Table.Row key={bill.id}>
            <Table.Cell align='left'>
              {bill.id}
            </Table.Cell>
            <Table.Cell align='right'>
              {bill.customer_id}
            </Table.Cell>
            <Table.Cell align='left'>
              {bill.created_at}
            </Table.Cell>
            <Table.Cell align='left'>
              {bill.due_at}
            </Table.Cell>
            <Table.Cell align='left'>
              {bill.customer_code}
            </Table.Cell>
            <Table.Cell align='left'>
              {bill.customer_name}
            </Table.Cell>
            <Table.Cell align='left'>
              {bill.payment_method_name}
            </Table.Cell>
            <Table.Cell align='right'>
              {toBrl(bill.amount)}
            </Table.Cell>
            <Table.Cell align='left'>
              <TagChip {...getPropsTagChipStatus(bill.status)} />
            </Table.Cell>
          </Table.Row>
        ))
      }
    </Table.Body>
  </Table.Container>
);

export default TableBills;
